import { render, staticRenderFns } from "./DialogSelectClass.vue?vue&type=template&id=0f8d458a&scoped=true&"
import script from "./DialogSelectClass.vue?vue&type=script&lang=js&"
export * from "./DialogSelectClass.vue?vue&type=script&lang=js&"
import style0 from "./DialogSelectClass.vue?vue&type=style&index=0&id=0f8d458a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8d458a",
  null
  
)

export default component.exports